export function ordernarAnalise(analise) {
  return analise.sort((x, y) => {
    if (!x.otimizado && y.otimizado) return -1;
    else if (x.otimizado && !y.otimizado) return 1;

    return x?.titulo?.localeCompare(y.titulo);
  });
}

export const removerArtigoDuplicado = metricas => {
  const unicos = [];

  metricas.forEach(item => {
    if (!unicos.some(obj => obj.idArtigo === item.idArtigo)) {
      unicos.push(item);
    }
  });
  return unicos;
};

export const obterDadosEditorJs = () => {
  if (!localStorage.getItem('artigo_em_edicao')) return {};
  const artigoEmEdicao = localStorage.getItem('artigo_em_edicao');
  const artigoEmEdicaoJson = JSON.parse(artigoEmEdicao);

  return {
    id: parseInt(artigoEmEdicaoJson?.id),
    conteudo: JSON.parse(artigoEmEdicaoJson?.conteudo),
    html: artigoEmEdicaoJson?.html,
    imagem: artigoEmEdicaoJson?.imagem,
    palavrasChave: artigoEmEdicaoJson?.palavras_chave,
    titulo: artigoEmEdicaoJson?.titulo,
    metadescricao: artigoEmEdicaoJson?.metadescricao,
    alt_imagem: artigoEmEdicaoJson?.alt_imagem,
  };
};
